import clsx from 'clsx';
import React, { useContext, useEffect } from 'react';
import { useModal } from 'src/hooks/useModal';
import { I18nContext } from 'src/stores/I18n';
import { ModalIcon } from '../ModalIcon';
import styles from './index.module.scss';

export const NoticeModal: React.FC = () => {
  const { isVisible, setIsVisible, modalParams } = useModal('noticeModal');
  const localeResources = useContext(I18nContext);

  useEffect(() => {
    if (isVisible && modalParams.type === 'info') {
      setTimeout(() => {
        setIsVisible(false);
      }, 1500);
    }
  }, [modalParams.type, isVisible]);

  useEffect(() => {
    if (isVisible) {
      document.body.classList.add('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isVisible]);

  return isVisible ? (
    <div className={styles.cover} onClick={() => setIsVisible(false)}>
      <div className={clsx(styles.modal, modalParams.type === 'info' && styles.small)}>
        <ModalIcon type={modalParams.type} />
        {modalParams.title && <p className={styles.title}>{modalParams.title}</p>}
        {modalParams.text && (
          <p
            className={clsx(
              styles.text,
              modalParams.textPink && styles.pink,
              !modalParams.title && styles.withoutTitle
            )}
          >
            {modalParams.text}
          </p>
        )}
        {modalParams.extraData?.customElement && modalParams.extraData.customElement}
        {modalParams.type === 'warning' && (
          <button className={styles.closeButton} onClick={() => setIsVisible(false)}>
            {modalParams.buttonTitle ?? localeResources.commons.dismiss}
          </button>
        )}
      </div>
    </div>
  ) : null;
};
